export default __webpack_public_path__ + "media/Evening.5239cab2.svg";